<template lang="pug">
div.card-body(@click="navigate")
  div.card-image
    nuxt-img(
      v-if="image",
      :src="image",
      :alt="`${title}`",
      loading="lazy",
      height="100%",
      width="100%"
    )
  div.card-info
    EcreativArchetypesHeading.fs-7.mb-1(
      v-if="title",
      tag="h4",
      context="white",
      class="title"
    ) {{ title }}
    EcreativArchetypesHeading.fs-7.mb-1(
      v-if="subTitle",
      class="subTitle",
      tag="h4",
      size="6"
    ) {{ subTitle }}
    time(
      v-if="time",
      class="text-white",
      :datetime="time"
    ) {{ time }}
</template>

<script lang="ts" setup>
import { useRouter } from 'vue-router';
import EcreativArchetypesHeading from '../../archetypes/Heading';

const router = useRouter();

const props = defineProps({
  image: {
    type: String,
    default: '',
  },
  title: {
    type: String,
    default: '',
  },
  subTitle: {
    type: String,
    default: '',
  },
  time: {
    type: String,
    default: '',
  },
  link: {
    type: String,
    default: '#',
  },
});

const navigate = (e?: MouseEvent) => {
  e?.preventDefault?.();
  e?.stopPropagation?.();

  if (process.server || !props.link) return;

  const href =
    typeof props.link === 'string'
      ? props.link
      : router.resolve(props.link).href;

  // Open a blank tab (no features) so Safari returns a Window reference.
  const w = window.open('', '_blank'); // user-gesture required

  if (w) {
    // Prevent reverse-tabnabbing without relying on 'noopener' feature.
    w.opener = null;
    w.location.href = href;
  } else {
    // If a popup blocker intervenes, you can choose to do nothing,
    // or as a last resort navigate same tab:
    // window.location.assign(href)
  }
};
</script>

<style lang="scss" scoped>
.card-body {
  border-top-left-radius: $border-radius-sm;
  border-top-right-radius: $border-radius-sm;
  cursor: pointer;
}

.card-image {
  flex: 0 0 80%;
}

.card-info {
  flex: 1;
  padding-top: 10px;
}

.subTitle {
  color: hsl(0deg 0% 70%);
  font-size: 0.8rem;
}
</style>
